/* Fietspack — ALL buying goes to our own checkout (bridge → Airwallex).
   Built 2026-09-30, made store-wide 2026-10-01 ("make it work correctly for all products on the
   store, even on add to cart after clicking checkout should send to our checkout.fietspack").

   Nothing in this store reaches Shopify's cart or Shopify's checkout any more:
     • add-to-cart / buy-it-now / quick-add  → straight to checkout.fietspack.shop
     • the /cart page and the cart drawer    → whole cart handed over, Shopify cart emptied
     • Shop Pay / Apple Pay / dynamic wallet buttons → hidden everywhere
   There is deliberately NO per-variant allow-list: the pay app prices every variant from its own
   snapshot (config/products.json, rebuilt from Shopify every 10 min by sync-catalog.mjs) and looks
   up anything it does not know at pay time (ensureCatalog), so a product added to Shopify minutes
   ago already sells. Prices in this file are DISPLAY ONLY — the server re-prices on variant id,
   so a tampered page cannot change what is charged.

   The lander/shed templates do their own hand-off (lander.js / shed.js) and never hit this file. */
(function () {
  'use strict';

  var PAY = 'https://checkout.fietspack.shop';
  var CDN = 'https://cdn.shopify.com/s/files/1/1010/3606/5142/'; // shop id split 1/ + 4-4-4

  /* ── kill the wallets (Shop Pay / Apple Pay / dynamic checkout) ──
     Store-wide: Shopify's checkout is never the destination, so a wallet button can only
     take a buyer somewhere we don't settle. */
  try {
    var st = document.createElement('style');
    st.id = 'fp-bridge-nowallet';
    st.textContent = '.shopify-payment-button,[data-shopify="payment-button"],shopify-accelerated-checkout,'
      + 'shopify-accelerated-checkout-cart,.dynamic-checkout__content,.additional-checkout-buttons,'
      + '.shopify-payment-button__button,.shopify-payment-button__more-options{display:none!important}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}

  /* ── product data (title / price / image per variant) ──────────── */
  var CACHE = {}, PENDING = {};
  function pathHandle() { var m = location.pathname.match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; }
  /* A quick-add form on a collection or home card is NOT on /products/<handle>, so the handle has
     to come from the card's own product link — taking it from the path priced those hand-offs at
     €0,00 while the checkout charged the real catalogue price. */
  function handleFor(form) {
    var el = form, hops = 0, link = null;
    while (el && hops++ < 7 && !link) {
      try { link = el.querySelector ? el.querySelector('a[href*="/products/"]') : null; } catch (e) {}
      el = el.parentElement;
    }
    if (link) {
      var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    return pathHandle();
  }
  function loadProduct(h) {
    if (!h) return Promise.resolve(null);
    if (CACHE[h]) return Promise.resolve(CACHE[h]);
    if (PENDING[h]) return PENDING[h];
    PENDING[h] = fetch('/products/' + h + '.js', { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (j) { CACHE[h] = j; return j; })
      .catch(function () { return null; });
    return PENDING[h];
  }
  if (pathHandle()) { try { loadProduct(pathHandle()); } catch (e) {} }  // warm it before the click

  function cdnify(s) {
    s = String(s || '').split('?')[0];
    if (s.indexOf('//') === 0) s = 'https:' + s;
    return s.replace(/^https?:\/\/[^/]*fietspack\.shop\/cdn\/shop\//, CDN);  // never name the storefront
  }

  /* ── attribution → checkout (same keys/behaviour as shed.js) ───── */
  function attrQs() {
    var qs = '';
    try {
      var gp = function (n) { var m = (location.search || '').match(new RegExp('[?&]' + n + '=([^&]+)')); try { return m ? decodeURIComponent(m[1].replace(/\+/g, '%20')) : ''; } catch (e) { return ''; } };
      var gc = function (n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]+)')); return m ? m[1] : ''; };
      var at = { ttclid: gp('ttclid'), fbclid: gp('fbclid'), gclid: gp('gclid'),
                 utm_source: gp('utm_source'), utm_medium: gp('utm_medium'), utm_campaign: gp('utm_campaign'),
                 utm_content: gp('utm_content'), aff: gp('aff'), ttp: gc('_ttp') };
      var st0 = {}; try { st0 = JSON.parse(sessionStorage.getItem('fp_attr0') || '{}') || {}; } catch (e) { st0 = {}; }
      for (var k in st0) { if (!at[k] && st0[k]) at[k] = String(st0[k]); }
      for (var a in at) { if (at[a]) qs += '&' + a + '=' + encodeURIComponent(at[a]); }
    } catch (e) {}
    return qs;
  }
  try {   /* first-touch snapshot, same key the lander/shed rails use */
    if (!sessionStorage.getItem('fp_attr0')) {
      var s0 = location.search || '', snap = {};
      ['ttclid', 'fbclid', 'gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'aff'].forEach(function (n) {
        var m = s0.match(new RegExp('[?&]' + n + '=([^&]+)'));
        if (m) { try { snap[n] = decodeURIComponent(m[1].replace(/\+/g, '%20')); } catch (e) {} }
      });
      if (Object.keys(snap).length) sessionStorage.setItem('fp_attr0', JSON.stringify(snap));
    }
  } catch (e) {}

  function handoff(items, total) {
    var cart = { cur: 'EUR', sym: '€', total: Math.round(total * 100) / 100, items: items };
    var b64 = btoa(unescape(encodeURIComponent(JSON.stringify(cart))))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    window.location.href = PAY + '/pay/?cart=' + b64 + attrQs();
  }

  /* ── one product (PDP buy box, quick-add card) ─────────────────── */
  function go(vid, qty, h) {
    return loadProduct(h).then(function (P) {
      var v = null;
      if (P && P.variants) for (var i = 0; i < P.variants.length; i++) if (String(P.variants[i].id) === String(vid)) v = P.variants[i];
      // No product JSON (renamed handle, offline) → the hand-off would read €0,00 while the
      // checkout charges the catalogue price. Refuse; the caller sends them to the PDP instead.
      if (!v || !(Number(v.price) > 0)) return Promise.reject(new Error('no price for variant ' + vid));
      var euros = Math.round(Number(v.price) || 0) / 100;
      var vlabel = (v.title && v.title !== 'Default Title') ? ' — ' + v.title : '';
      var q = Math.max(1, parseInt(qty, 10) || 1);
      var line = Math.round(euros * q * 100) / 100;
      handoff([{ id: String(vid), q: q, title: ((P && P.title) || document.title || 'Product') + vlabel,
                 line: line, img: cdnify((v.featured_image && v.featured_image.src) || (P && P.featured_image)) }], line);
    });
  }

  /* ── the whole Shopify cart (cart page + cart drawer) ───────────
     Most variants can't even get in there (stock 0, oversell off → /cart/add.js 422), but the
     ones that allow overselling can, and that cart's "Afrekenen" used to post to Shopify's own
     checkout. Hand every line over instead, then empty the Shopify cart. */
  function cartHandoff(e, el) {
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    var btn = (el.tagName === 'BUTTON' || el.tagName === 'INPUT') ? el : null;
    var lbl = btn ? btn.innerHTML : '';
    if (btn) { if (btn.dataset.fpBusy) return; btn.dataset.fpBusy = '1'; }
    var release = function () { if (btn) { btn.innerHTML = lbl; delete btn.dataset.fpBusy; } };
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || !c.items || !c.items.length) { release(); location.href = '/'; return; }
        var items = [], total = 0;
        for (var i = 0; i < c.items.length; i++) {
          var li = c.items[i];
          var line = Math.round(Number(li.final_line_price != null ? li.final_line_price : li.line_price) || 0) / 100;
          total += line;
          items.push({ id: String(li.variant_id), q: li.quantity || 1,
            title: (li.product_title || li.title || 'Product') + ((li.variant_title && li.variant_title !== 'Default Title') ? ' — ' + li.variant_title : ''),
            line: line, img: cdnify(li.image || (li.featured_image && li.featured_image.url)) });
        }
        // empty it on the way out so a returning buyer isn't nagged by lines they already paid
        // for on the bridge. keepalive: the redirect must not wait for this.
        try { fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', keepalive: true }); } catch (e2) {}
        handoff(items, total);
      })
      .catch(function () { release(); });
  }

  /* ── wiring ────────────────────────────────────────────────────── */
  function formOf(el) { return el && el.closest ? el.closest('form[action*="/cart/add"]') : null; }
  function variantOf(form) {
    var i = form && form.querySelector('input[name="id"], select[name="id"]');
    if (i && i.value) return String(i.value);
    var m = (location.search || '').match(/[?&]variant=(\d+)/);
    return m ? m[1] : '';
  }
  function qtyOf(form) {
    var i = form && form.querySelector('[name="quantity"]');
    return i && i.value ? i.value : 1;
  }

  /* Capture phase + stopImmediatePropagation: Horizon binds its own handler on the button
     (on:click="/handleClick"), so anything less lets the theme add the line to the Shopify
     cart as well. */
  function intercept(e, el) {
    var form = formOf(el);
    if (!form) return;
    var vid = variantOf(form);
    if (!vid) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    var btn = (el.tagName === 'BUTTON' || el.tagName === 'INPUT') ? el : null;
    var lbl = btn ? btn.innerHTML : '';
    if (btn) { if (btn.dataset.fpBusy) return; btn.dataset.fpBusy = '1'; }
    var h = handleFor(form);
    go(vid, qtyOf(form), h).catch(function () {
      if (btn) { btn.innerHTML = lbl; delete btn.dataset.fpBusy; }
      // couldn't price it here — the product page always can
      if (h && !/\/products\//.test(location.pathname)) location.href = '/products/' + h;
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    // cart/drawer checkout first — those controls are not add-to-cart buttons
    var ck = e.target.closest('button[name="checkout"],input[name="checkout"],a[href="/checkout"],a[href^="/checkout?"],[data-testid="cart-checkout-button"]');
    if (ck) { cartHandoff(e, ck); return; }
    var t = e.target.closest('button[name="add"],input[name="add"],[data-testid="standalone-add-to-cart"],.add-to-cart-button,button[type="submit"]');
    if (t) intercept(e, t);
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches) return;
    if (f.matches('form[action*="/cart/add"]')) { intercept(e, f); return; }
    if (f.matches('form[action^="/cart"]') && f.querySelector('[name="checkout"]')) cartHandoff(e, f);
  }, true);
})();
